import { Col, Row } from "react-bootstrap";
import { SearchFieldPM } from "../../interfaces/AdvancedSearch/SearchFieldPM";
import { useRef } from "react";
import FindCheckBoxList from "./FindCheckBoxList";
import { iQueueGridState } from "../../interfaces/lastTouched";

interface props {
    searchField: SearchFieldPM;
    onChange: (searchField: SearchFieldPM) => void;
    children: iQueueGridState[];
    history?: string[] | undefined;
    disabled?: boolean;
}

function SearchFieldRowCheckList(props: props) {
    const inputFocusRef = useRef(false);

    const searchField = props.searchField;

    function setEnabled() {
        searchField.Enabled = !searchField.Enabled;

        if (searchField.Enabled) {
            inputFocusRef.current = true;
        }

        props.onChange(searchField);
    }

    function setValue(newValue: string) {
        searchField.Value = newValue;
        props.onChange(searchField);
    }

    function onInputColClick() {
        if (!searchField.Enabled) {
            setEnabled();
        }
    }
    return (
        <Row className="rowMarginControl">
            <Col xs={4}>
                <input
                    className="g-Checkbox-default"
                    type="checkbox"
                    checked={props.disabled ? !props.disabled : searchField.Enabled}
                    onChange={setEnabled}
                    disabled={props.disabled}
                />
                <label
                    className="g-label "
                    onClick={setEnabled}
                >
                    {searchField.Label}
                </label>
            </Col>
            <Col
                xs={8}
                onClick={onInputColClick}
            >
                <FindCheckBoxList
                    id={22}
                    label={props.searchField.Label}
                    enabledButton={props.disabled ? !props.disabled : searchField.Enabled}
                    onChange={e => setValue(e)}
                    history={props.history}
                >
                    {props.children.map((item, index) => (
                        <li key={item.Name}>
                            <button
                                className="CheckBoxList-Label"
                                onClick={() => {}}
                            >
                                {item.Label.replace(/ /g, "\u00a0")}
                            </button>
                        </li>
                    ))}
                </FindCheckBoxList>
            </Col>
        </Row>
    );
}

export default SearchFieldRowCheckList;
